import KDriverBreakToggle from "./KDriverBreakToggle";
import UserField from "kinnect-front/User/UserField";
import { KForm, KTextField } from "kinnect-general";
import { FetchesData } from "kinnect-mixins";
import { User } from "kinnect-models";
import { VSwitch } from "vuetify/lib";

export default KForm.extend( {
	name: "KDriverForm",

	props: {
		driver: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "yardDrivers" } ]
		}
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			cdl: false,
			idUser: null,
			onBreak: false,
			temporary: false
		},
		users: null
	} ),

	computed: {
		editing() {
			return Boolean( this.driver );
		},

		formUrl() {
			return this.editing ? `yard/drivers/${this.driver.id}` : "yard/drivers";
		}
	},

	watch: {
		driver: {
			handler( driver ) {
				if ( driver ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( driver.hasOwnProperty( key ) ) {
							this.formFields[key] = driver[key];
						}
					} );

					this.formFields.idUser = driver.user.id;
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchUsers() {
			if ( !this.editing ) {
				this.users = await User.custom( "users/exclude-drivers" ).get();
			}
		},

		async fetch() {
			await this.fetchUsers();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			{this.editing
				? <KTextField
					disabled
					label="User"
					loading={this.$wait.is( "find driver" )}
					prependIcon="person"
					value={this.fetched ? this.driver.user.name : "Loading..."}
				></KTextField>
				: <UserField
					items={this.users || []}
					label="User*"
					loading={this.$wait.is( "get users" )}
					required
					vModel={this.formFields.idUser}
					validationName="user"
					validationRules="required"
				></UserField>
			}

			<VSwitch
				class="ml-blank-icon"
				color="accent"
				falseValue={false}
				inputValue={this.formFields.cdl}
				inset
				label="Has CDL"
				onChange={cdl => this.formFields.cdl = cdl}
				trueValue={true}
			></VSwitch>

			<VSwitch
				class="ml-blank-icon"
				color="accent"
				falseValue={false}
				inputValue={this.formFields.temporary}
				inset
				label="Temporary Driver"
				onChange={temporary => this.formFields.temporary = temporary}
				trueValue={true}
			></VSwitch>

			<KDriverBreakToggle
				class="ml-blank-icon"
				vModel={this.formFields.onBreak}
			></KDriverBreakToggle>
		</KForm>;
	}
} );
